/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Timing_LabelInputs */



/**
* | output |
* | --- |
* | "Timing" |
*
* @param {Error_Nav_Timing_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_timing_label = /** @type {((inputs?: Error_Nav_Timing_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Timing_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Minutage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Timing")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tempistica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Время")
	if (locale === "es") return /** @type {LocalizedString} */ ("Momento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("定时")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tempo")
	return /** @type {LocalizedString} */ ("Timing")
});